import { Component, Input, OnInit } from '@angular/core'
import { ConsoleLogger } from 'src/lib/console-logger'
import { Maintenance503Res } from 'src/lib/entity/live'

@Component({
  selector: 'maglive-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {
  @Input() authority: Maintenance503Res | undefined

  startedAt = ''
  endedAt = ''

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    this.logger.message(this.constructor.name, 'ngOnInit', 'maintenance')
    if (this.authority !== undefined) {
      this.startedAt = new Date(
        this.authority.maintenanceMetadata.startedAt * 1000
      ).toISOString()
      this.endedAt = new Date(
        this.authority.maintenanceMetadata.endedAt * 1000
      ).toISOString()
    }
  }
}
